/**
 * Безопасное преобразование значения в число.
 * Поддерживает number и строковые числовые значения (в т.ч. с запятой).
 */
export const toNumberSafe = (value: unknown): number | null => {
  if (typeof value === 'number') {
    return !isNaN(value) && isFinite(value) ? value : null
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) return null

    const num = Number(trimmed.replace(',', '.'))

    return !isNaN(num) && isFinite(num) ? num : null
  }

  return null
}

/**
 * Нормализация широты и долготы.
 * Возвращает кортеж [lat, lng] или null, если координаты некорректны.
 */
export const normalizeLatLng = (lat: unknown, lng: unknown): [number, number] | null => {
  const latNum = toNumberSafe(lat)
  const lngNum = toNumberSafe(lng)

  if (latNum === null || lngNum === null) return null

  if (latNum < -90 || latNum > 90 || lngNum < -180 || lngNum > 180) return null

  return [latNum, lngNum]
}
